import ImportImages from '@src/importImages';

const PdfFile = ImportImages(
  '/news/JetSuite-Aviation-for-Women-August-21-2019.pdf'
);
const FlyingInPdf = ImportImages(
  '/news/JetSuite-Bespoke-Concierge-August-2019.pdf'
);
const HypericePdf = ImportImages(
  '/news/JetSuite-Hyperice-Partnership-FINAL.pdf'
);
const DallasPdf = ImportImages('/news/Dallas-Business-Journal-online.pdf');

export default [
  // March
  {
    title: 'JetSuite’s Stephanie Chung',
    date: 'March 29th, 2019',
    source: 'Business Jet Traveler',
    link:
      'https://www.bjtonline.com/business-jet-news/jetsuites-stephanie-chung'
  },
  {
    title:
      'Bring in the Robot Cleaners: Travel Industry Innovations for the Pandemic',
    date: 'March 28th, 2020',
    source: 'The New York Times',
    link:
      'https://www.nytimes.com/2020/03/28/travel/coronavirus-hotels-private-jets-virtual-spas.html'
  },
  {
    title:
      'This Airline Is Flying Stranded Seniors Home via Private Jet amid Coronavirus Pandemic',
    date: 'March 27th, 2020',
    source: 'Travel + Leisure',
    link:
      'https://www.travelandleisure.com/airlines-airports/jsx-flew-stranded-seniors-home-coronavirus'
  },
  {
    title: 'JetSuite Sets 10-hour Jet Card in Covid-19 Response',
    date: 'March 26th, 2020',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2020/03/26/jetsuite-sets-10-hour-jet-card-in-covid-19-response/'
  },
  {
    title:
      'Private Jet Companies Innovate as Covid-19 Coronavirus Disrupts the Worldwide Travel Industry',
    date: 'March 25th, 2020',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/douggollan/2020/03/25/private-jet-companies-innovate-as-covid-19-coronavirus-disrupts-the-worldwide-travel-industry/#40ea752045f5'
  },

  {
    title:
      'Privatefly, JetSuite, Jsx, Globeair Share Covid-19 Private Jet Rescue Flight Stories',
    date: 'March 25th, 2020',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2020/03/25/privatefly-jsx-globeair-share-covid-19-private-jet-rescue-flight-stories/'
  },
  {
    title: 'Jetting to Arts and Culture',
    date: 'March 25th, 2020',
    source: 'Barron’s Penta',
    link:
      'https://www.barrons.com/articles/jetting-to-arts-and-culture-51585148400'
  },
  {
    title:
      'After Initial Uptick, Dallas Private Aviation Companies Start to See Decline',
    date: 'March 23rd, 2020',
    source: 'Dallas Business Journal',
    link: DallasPdf
  },
  {
    title:
      'Of Course the Rich Are Getting Tested First. The Wealthy Always Do Better During a Pandemic',
    date: 'March 18th, 2020',
    source: 'The Washington Post',
    link:
      'https://www.washingtonpost.com/lifestyle/of-course-the-rich-are-getting-tested-first-the-wealthy-always-do-better-during-a-pandemic/2020/03/18/3b6e1c04-689b-11ea-b313-df458622c2cc_story.html'
  },
  {
    title: 'Top Executives on Coronavirus and Its Impact on Private Aviation',
    date: 'March 18th, 2020',
    source: 'Elite Traveler',
    link:
      'https://www.elitetraveler.com/luxury-transport/private-jets/how-coronavirus-is-impacting-the-private-jet-industry'
  },
  {
    title: 'Private Jets Get a Lift as Commercial Planes Are Grounded',
    date: 'March 17th, 2020',
    source: 'Wall Street Journal',
    link:
      'https://www.wsj.com/articles/private-jets-get-a-lift-as-commercial-planes-are-grounded-11584461475'
  },
  {
    title: 'Private Jet Service Booms amid Coronavirus Fears',
    date: 'March 11th, 2020',
    source: 'FOX Business',
    link:
      'https://www.foxbusiness.com/lifestyle/private-jet-service-surges-coronavirus'
  },
  {
    title: 'The 50 Most Important Women in Travel',
    date: 'March 1st, 2020',
    source: 'WonderLust',
    link:
      'https://wonderlusttravel.com/50-most-important-women-in-travel-16-20/'
  },
  // February
  {
    title: 'JetSuite’s Chung Named to 2020 Ebony Power 100 List',
    date: 'February 28th, 2020',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2020/02/28/jetsuites-chung-named-to-2020-ebony-power-100-list/'
  },
  {
    title: '2020 Ebony Power 100 List',
    date: 'February 26th, 2020',
    source: 'EBONY',
    link: 'https://www.ebony.com/exclusive/2020-ebony-power-100-list/'
  },
  {
    title: 'The Ultimate Guide to Flying Privately',
    date: 'February 19th, 2020',
    source: 'Elite Traveler',
    link:
      'https://www.elitetraveler.com/luxury-transport/private-jets/ultimate-guide-fly-by-private-jet'
  },
  // January
  {
    title: 'JetSuite, JSX Get Top Score for Inclusion',
    date: 'January 23rd, 2020',
    source: 'AIN Online',
    link:
      'https://www.ainonline.com/aviation-news/business-aviation/2020-01-23/jetsuite-jsx-get-top-score-inclusion'
  },
  {
    title:
      'JetSuite and JSX Earn Perfect Score in 2020 Corporate Quality Index Ranking',
    date: 'January 23rd, 2020',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2020/01/23/jetsuite-and-jsx-earn-perfect-score-in-2020-corporate-quality-index-ranking/'
  },
  {
    title: 'JetSuite and JSX Earn Top Marks in 2020 Corporate Equality Index',
    date: 'January 21st, 2020',
    source: 'Press Release',
    link:
      '/news/jetsuite-and-jsx-earn-perfect-score-in-2020-corporate-quality-index-ranking'
  },
  {
    title: 'JetSuite Makes “Suite-heart” Offer for Valentine’s Day',
    date: 'January 16th, 2020',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2020/01/16/jetsuite-makes-suite-heart-offer-for-valentines-day/'
  },
  {
    title: 'Jetting Around: How to Avoid Travel Hassles This Awards Season',
    date: 'January 3rd, 2020',
    source: 'Variety',
    link:
      'https://variety.com/2020/film/awards/jetting-around-how-to-avoid-travel-hassles-this-awards-season-1203455359/'
  },
  // December
  {
    title: 'JetSuite Promotes Private Jet Travel on Extra TV',
    date: 'December 15th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/12/15/jetsuite-promotes-private-jet-travel-on-extra-tv/'
  },
  {
    title: 'JetSuite Expands Luxury Travel Experiences',
    date: 'December 11th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/12/11/jetsuite-expands-luxury-travel-experiences/'
  },
  {
    title: "JetSuite's Stephanie Chung Among WAI 2020 Keynotes",
    date: 'December 3rd, 2019',
    source: 'AIN Online',
    link:
      'https://www.ainonline.com/aviation-news/business-aviation/2019-12-03/jetsuites-stephanie-chung-among-wai-2020-keynotes'
  },
  // November
  {
    title: 'JetSuite Partners with Hyperice for Pilot Wellness Program',
    date: 'November 1st, 2019',
    source: 'Dallas Innovates',
    link:
      'https://dallasinnovates.com/jetsuite-partners-with-hyperice-for-pilot-wellness-program/'
  },
  // October
  {
    title:
      'Hyperice Partners with JetSuite To OfferTechnology-Based Health and Wellness Program for Pilots',
    date: 'October 29th, 2019',
    source: 'Press Release',
    link: HypericePdf
  },
  {
    title: 'JetSuite Prioritizes Pilots’ Wellness with Recovery Program',
    date: 'October 29th, 2019',
    source: 'Luxury Daily',
    link: 'https://www.luxurydaily.com/videos/?id=281355&num=1'
  },
  {
    title: 'JetSuite Partners with Hyperice to Enhance Pilot Wellness',
    date: 'October 29th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/10/29/jetsuite-jet-card-partners-to-enhance-pilot-wellness/'
  },

  {
    title:
      'Private Jet Companies Take Flight For Breast Cancer Awareness Month',
    date: 'October 28th, 2019',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/douggollan/2019/10/28/private-jet-companies-take-flight-for-breast-cancer-awareness-month/#79be418d3000'
  },
  {
    title: 'JetSuite President Stephanie Chung on Evolving Leadership',
    date: 'October 14th, 2019',
    source: 'Elite Traveler',
    link:
      'https://www.elitetraveler.com/leaders-in-luxury/jetsuite-president-stephanie-chung-on-evolving-leadership'
  },
  // September
  {
    title: 'Private-Jet Pampering',
    date: 'September 22nd, 2019',
    source: 'Barron’s Penta',
    link: 'https://www.barrons.com/articles/private-jet-pampering-51569157201'
  },
  {
    title: 'What They’re Reading: Book Picks From Business Leaders',
    date: 'September 21st, 2019',
    source: 'Barron’s Penta',
    link:
      'https://www.barrons.com/articles/what-theyre-reading-book-picks-from-business-leaders-51569070802'
  },
  {
    title:
      'JetSuite is Phenom 300 Focused With Plans to Add New Private Jet Types',
    date: 'September 10th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/09/10/jetsuite-is-phenom-300-focused-with-plans-to-add-new-private-jet-types/'
  },
  {
    title: 'Aviation for Women',
    date: 'September / October 2019',
    source: 'Aviation for Women',
    link: PdfFile
  },
  {
    title: 'Stephanie Chung on Evolving Leadership',
    date: 'Fall 2019',
    source: 'Elite Traveler',
    link: 'https://user-35215390377.cld.bz/Elite-Traveler-Fall-2019/80/#zoom=z'
  },
  {
    title: 'Flying In',
    date: 'Summer / Fall 2019',
    source: 'BESPOKE CONCIERGE',
    link: FlyingInPdf
  },
  // August
  {
    title: ' 5 Private Jet Companies That Make Flying a Breeze',
    date: 'August 27th, 2019',
    source: 'Better',
    link:
      'https://better.net/travel/5-private-jet-companies-that-make-flying-a-breeze/'
  },
  {
    title: 'Experience the Spring 2020 Collections - Front Row - with JetSuite',
    date: 'August 21st, 2019',
    source: 'Luxury Travel Magazine',
    link:
      'https://www.luxurytravelmagazine.com/news-articles/experience-the-spring-2020-collections-front-row-with-jetsuite'
  },
  {
    title: 'How Much Does a Private Jet Cost?',
    date: 'August 7th, 2019',
    source: 'AFAR',
    link: 'https://www.afar.com/magazine/how-much-does-a-private-jet-cost'
  },
  {
    title:
      'Facing An Industry Pilot Shortage, Southwest Airlines And Jet Linx Aviation Have A Plan For That',
    date: 'August 1st, 2019',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/douggollan/2019/08/01/facing-an-industry-pilot-shortage-southwest-airlines-and-jet-linx-aviation-have-a-plan-for-that/#19565a891d0b'
  },
  // July
  {
    title: 'Jetsuite Launches U.s. Open Tennis Vip Access for Suitekey Members',
    date: 'July 18th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/07/18/jetsuite-launches-u-s-open-tennis-vip-access-for-suitekey-members/'
  },
  {
    title: 'Experience The U.S. OPEN Center Court with JetSuite',
    date: 'July 18th, 2019',
    source: 'Wealth Magazine',
    link:
      'http://wealth-magazine.com/2019/07/18/experience-the-u-s-open-center-court-with-jetsuite/'
  },
  {
    title: 'Experience The U.S. OPEN Center Court with JetSuite',
    date: 'July 18th, 2019',
    source: 'Luxury Travel Magazine',
    link:
      'https://www.luxurytravelmagazine.com/news-articles/experience-the-us-open-center-court-with-jetsuite'
  },
  //June
  {
    title: 'Four Women Leaders Breaking Barriers in Their Industries',
    date: 'June 2019',
    source: 'D CEO',
    link:
      'https://www.dmagazine.com/publications/d-ceo/2019/june/four-women-leaders-breaking-barriers-in-their-industries/'
  },
  {
    title:
      'The Best Present You Can Give Is Your Presence’: JetSuite’s Stephanie Chung on What Spells Success',
    date: 'June 28th, 2019',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/stephanie-chung-jetsuite-sucess-2855742/'
  },
  {
    title: 'Experience JetSuite this Summer',
    date: 'June 18th, 2019',
    source: 'Luxury Travel Magazine',
    link:
      'https://www.luxurytravelmagazine.com/news-articles/experience-jetsuite-this-summer'
  },

  // Test
  {
    title: '32 New DFW CEOs You Need to Know',
    date: 'May 2019',
    source: 'D Maganize',
    link:
      'https://www.dmagazine.com/publications/d-ceo/2019/may/the-32-new-dfw-ceos-you-need-to-know-right-now/'
  },
  {
    title: 'JetSuite Debuts JetSuite Experiences for Discerning Travelers',
    date: 'May 9th, 2019',
    source: 'Elite Traveler',
    link:
      'https://www.elitetraveler.com/luxury-transport/jetsuite-debuts-jetsuite-experiences-for-discerning-travelers'
  },
  {
    title:
      "Jet Card Insider: If You Think You Know JetSuite, You Don't Know JetSuite",
    date: 'May 6th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/05/06/jet-card-insider-jetsuite-remakes-its-suitekey-jet-card-membership/'
  },
  {
    title: 'JetSuite Partners With Embark, Announces Sustainable Measures',
    date: 'May 3rd, 2019',
    source: 'Luxury Travel Advisor',
    link:
      'https://www.luxurytraveladvisor.com/running-your-business/new-offers-by-jetsuite'
  },
  {
    title:
      'JetSuite Raises the Bar for Personalized Luxury Travel WithFirst-of-its-kind Partnership: “JetSuite Experiences” by Embark',
    date: 'May 2nd, 2019',
    source: 'Press Release',
    link: '/news/jetsuite-raises-the-bar-for-personalized-luxury-travel'
  },
  {
    title: 'JetSuite to Offer Personalized Travel Experiences',
    date: 'May 2nd, 2019',
    source: 'Market Watch',
    link:
      'https://www.marketwatch.com/story/jetsuite-partners-with-embark-to-offer-personalized-travel-experiences-2019-05-02?siteid=rss'
  },
  {
    title: 'JetSuite Launches JetSuite Experiences',
    date: 'May 2nd, 2019',
    source: 'Pursuitist',
    link: 'https://pursuitist.com/jetsuite-launches-jetsuite-experiences/'
  },
  {
    title: 'JetSuite to Offer Personalized Travel Experiences',
    date: 'May 2nd, 2019',
    source: "Barron's",
    link:
      'https://www.barrons.com/articles/jetsuite-partners-with-embark-to-offer-personalized-travel-experiences-01556831537'
  },
  {
    title:
      'Jetsuite Launches a Travel Agency Partnership Providing Total Travel Services for Its Clients',
    date: 'May 1st, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/05/01/jet-card-jetsuite-launches-travel-agency-partnership-to-provide-360-degrees-travel-services-for-its-clients/'
  },
  {
    title: 'Stephanie Chung On Overcoming Adversity, Sales, And Leadership',
    date: 'April 17th, 2019',
    source: 'Lean Systems',
    link: 'https://www.leansystems.co/podcast/stephanie-chung-jetsuite'
  },
  {
    title: 'President of JetSuite Flies Through Aviation Glass Ceiling',
    date: 'February 28th, 2019',
    source: 'NBC DFW',
    link:
      'https://www.nbcdfw.com/news/business/Stephanie-Chung-First-CEO-African-American-Of-Private-Jet-Company-Flies-Through-Glass-Cieling-506493831.html'
  },
  {
    title: 'JetSuite Inc. President Stephanie Chung Is the World’s Best Packer',
    date: 'February 11th, 2019',
    source: 'Fast Company',
    link:
      'https://www.fastcompany.com/90297279/jetsuite-inc-president-stephanie-chung-is-the-worlds-best-packer'
  },
  {
    title: 'JetSuite Adding Aircraft in 2019',
    date: 'January 28th, 2019',
    source: 'Business Jet Traveler',
    link:
      'https://www.bjtonline.com/business-jet-news/jetsuite-adding-aircraft-in-2019'
  },
  {
    title: 'The Biggest Private Jet Stories For 2019 Predicted',
    date: 'January 25th, 2019',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/douggollan/2019/01/25/the-biggest-private-jet-stories-for-2019-predicted/#67b71ca82936'
  },
  {
    title: 'How to Shape Your Leadership Style and Career',
    date: 'January 25th, 2019',
    source: 'Girl Scouts',
    link:
      'https://www.girlscouts.org/en/about-girl-scouts/our-stories/alumnae/how-to-shape-your-leadership-style-and-career.html'
  },
  {
    title: '20 Questions: Stephanie Chung',
    date: 'January 23rd, 2019',
    source: 'Worth',
    link: 'https://www.worth.com/20-questions-stephanie-chung/'
  },
  {
    title: 'JetSuite Looks to New Aircraft in Anniversary Year',
    date: 'January 11th, 2019',
    source: 'AIN Online',
    link:
      'https://www.ainonline.com/aviation-news/business-aviation/2019-01-11/jetsuite-looks-new-aircraft-anniversary-year'
  },
  {
    title: 'JetSuite Celebrates 10th Anniversary & Unveils Expansion Plans',
    date: 'January 11th, 2019',
    source: 'Luxury Travel Magazine',
    link:
      'https://www.luxurytravelmagazine.com/news-articles/jetsuite-celebrates-10th-anniversary-unveils-expansion-plans'
  },
  {
    title: 'JetSuite to Mark its 10th Year With Fleet Growth, New Amenities',
    date: 'January 11th, 2019',
    source: 'Luxury Travel Advisor',
    link:
      'https://www.luxurytraveladvisor.com/transportation/jetsuite-to-mark-its-tenth-year-fleet-growth-new-amenities'
  },
  {
    title:
      'Jetsuite Celebrates Its 10th Anniversary With 10-hour Jet Card Promotion',
    date: 'January 10th, 2019',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2019/01/10/jetsuite-celebrates-its-10th-anniversary-with-10-hour-jet-card-promotion/'
  },
  {
    title: 'JetSuite Partners with Luxury Brands for In-Flight Amenities',
    date: 'January 10th, 2019',
    source: 'Luxury Daily',
    link:
      'https://www.luxurydaily.com/jetsuite-partners-with-luxury-brands-for-in-flight-amenities/'
  },
  {
    title:
      'Leading Light Jet Operator, JetSuite, Inc., Celebrates 10 Years Of Continuous Operation In 2019',
    date: 'January 10th, 2019',
    source: 'Press Release',
    link: '/news/leading-light-jet-operator-jetsuite-inc-celebrate-10-years'
  },
  {
    title:
      'Ferrari Builds an Exclusive Version of the F12berlinetta For One Lucky Collector',
    date: 'December 4th, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/cars/ferrari-builds-exclusive-version-f12berlinetta-for-lucky-collector-2831910/'
  },
  {
    title: 'Black Friday 2018: Yes, Private Jet Flights Are on Sale, Too',
    date: 'November 21st, 2018',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/douggollan/2018/11/21/black-friday-2018-yes-private-jet-flights-are-on-sale-too/#2ded0fb9c274'
  },
  {
    title: 'JetSuite Has the Perfect Gift…Two Free $10,000 Jet Cards',
    date: 'November 20th, 2018',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2018/11/20/jetsuite-has-the-perfect-gift-two-free-10000-jet-cards/'
  },
  {
    title: 'An Aviation Industry Exec Who’s Smashing Barriers',
    date: 'November 4th, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/aviation-industry-exec-smashing-barriers-2826645/'
  },
  {
    title:
      "Boeing and JetBlue Are Betting Big on the Electric Plane Startup Zunum Aero. Here's How the Aviation Giants Are Helping the Company Take Off.",
    date: 'October 4th, 2018',
    source: 'Business Insider',
    link:
      'https://www.businessinsider.com/boeing-and-jetblue-help-electric-plane-zunum-go-to-market-2018-10?utm_source=email&utm_medium=referral&utm_content=topbar&utm_term=desktop&pt=385758&ct=Sailthru_BI_Newsletters&mt=8&utm_campaign=email_article'
  },
  {
    title: 'Hybrid-Electric Zunum Plane Gets Surge from Safran',
    date: 'October 4th, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/hybrid-electric-zunum-plane-gets-surge-from-safran-2821269/'
  },
  {
    title: 'MagniX Hits Milestone for All-Electric Aircraft Motors',
    date: 'September 27th, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/magnix-milestone-all-electric-aircraft-motors-2819972/'
  },
  {
    title:
      '"It\'s a Crummy Industry": CEO of Dallas Airline That Relocated from California Thinks He Has a $1B Idea',
    date: 'September 26th, 2018',
    source: 'Dallas Business Journal',
    link:
      'https://www.bizjournals.com/dallas/news/2018/09/26/jetsuite-alex-wilcox.html'
  },
  {
    title:
      'After Beating Cancer, Stephanie Chung Just Became The First Black President Of A Private Jet Company',
    date: 'September 11th, 2018',
    source: 'Essence',
    link:
      'https://www.essence.com/lifestyle/money-career/women-lets-win/beating-cancer-stephanie-chung-first-black-president-jet-company/'
  },
  {
    title: 'JetSuite President on the Business of Private Planes',
    date: 'August 29th, 2018',
    source: 'CNBC',
    link:
      'https://www.cnbc.com/video/2018/08/29/jetsuite-president-on-the-business-of-private-planes.html?&qsearchterm=jetsuite'
  },
  {
    title:
      'Stephanie Chung Breaks The Glass Ceiling In Business Aviation At JetSuite',
    date: 'August 22nd, 2018',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/douggollan/2018/08/22/stephanie-chung-breaks-the-glass-ceiling-in-business-aviation-at-jetsuite/#1388b974e78c'
  },
  {
    title:
      "JetSuite's Stephanie Chung Is the First African American Female President of a Major Bizav Company",
    date: 'August 22nd, 2018',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2018/08/22/jetsuites-stephanie-chung-is-the-first-african-american-president-of-a-major-bizav-company/#more-11037'
  },
  {
    title:
      'JetSuite, Inc. Appoints Stephanie Chung as President of the Dallas-Based Private Jet Aviation Company',
    date: 'August 22nd, 2018',
    source: 'ABC 6',
    link:
      'http://www.abc6.com/story/38937032/jetsuite-inc-appoints-stephanie-chung-as-president-of-the-dallas-based-private-jet-aviation-company'
  },
  {
    title:
      'JetSuite, Inc. Appoints Stephanie Chung as President of the Dallas-Based Private Jet Aviation Company',
    date: 'August 21st, 2018',
    source: 'Press Release',
    link: '/news/stephanie-chung-president-appointment-press-release'
  },
  {
    title:
      'JetSuite CEO Alex Wilcox on How Emerging Technology Will Affect Private Air Travel',
    date: 'August 1st, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/jetsuite-ceo-alex-wilcox-emerging-technology-private-air-travel-eg18-2808226/'
  },
  {
    title:
      'JetSuite Is Bringing Its Phenom 100s and Lower Prices to the East Coast for the Summer',
    date: 'June 7th, 2018',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2018/06/06/jetsuite-is-bringing-its-phenom-100s-and-lower-prices-to-the-east-coast-for-the-summer/#more-10362'
  },
  {
    title: 'JetSuite to Launch Hybrid-to-Electric Planes by 2022',
    date: 'May 24th, 2018',
    source: "Barron's Penta",
    link:
      'https://www.barrons.com/articles/jetsuite-to-launch-hybrid-to-electric-planes-by-2022-1527191523'
  },
  {
    title:
      'JetSuite Strikes a Deal for Hybrid Electric Planes with Start-Up Zunum Aero',
    date: 'May 21st, 2018',
    source: 'Los Angeles Times',
    link:
      'http://www.latimes.com/business/la-fi-hybrid-planes-jetsuite-20180521-story.html'
  },
  {
    title: "Zunum Aero's Electric Airplane Just Got Its First Customer",
    date: 'May 21st, 2018',
    source: 'Fast Company',
    link:
      'https://www.fastcompany.com/40575541/zunum-aeros-electric-airplane-just-got-its-first-customer'
  },
  {
    title:
      'JetSuite Announces Partnership with Zunum Aero to Acquire 100 of Its Hybrid-Electric Planes',
    date: 'May 21st, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/jetsuite-partnership-zunum-aero-first-hybrid-electric-planes-2795271/'
  },
  {
    title:
      'Hybrid-Electric Passenger Jet Gets 100-Plane Launch Order From JetSuite',
    date: 'May 21st, 2018',
    source: 'Forbes',
    link:
      'https://www.forbes.com/sites/michaelgoldstein/2018/05/22/hybrid-electric-passenger-jet-gets-100-plane-launch-order-from-jetsuite/#746a8e745c08'
  },
  {
    title:
      'Charter Flight Service JetSuite Receives Large Investment from Qatar Airways',
    date: 'April 17th, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/qatar-airways-buys-jetsuite-stake-air-charter-service-2789102/'
  },
  {
    title: 'Qatar Airways and JetBlue Help Boutique Charter Go National',
    date: 'April 12th, 2018',
    source: 'Bloomberg',
    link:
      'https://www.bloomberg.com/news/articles/2018-04-12/jetsuite-plans-a-100-plane-fleet-thanks-to-qatar'
  },
  {
    title: 'California Airline to Relocate Headquarters to DFW',
    date: 'April 12th, 2018',
    source: 'Biz Journals',
    link:
      'https://www.bizjournals.com/dallas/news/2018/04/12/jetsuite-headquarters-relation-california-dfw.html'
  },
  {
    title:
      'Qatar Airways invests in JetBlue-backed private jet company after American Airlines rebuff',
    date: 'April 10th, 2018',
    source: 'CNBC',
    link:
      'https://www.cnbc.com/2018/04/10/qatar-airways-invests-in-jetsuite-after-american-airlines-rebuff.html'
  },
  {
    title: 'Qatar Airways Announces Investment in JetSuite, Inc.',
    date: 'April 10th, 2018',
    source: 'Press Release',
    link: '/news/qatar-airways-announces-investment-in-jetsuite-inc'
  },
  {
    title: 'Hitch a Ride on a Private Jet',
    date: 'April 3rd, 2018',
    source: 'Wall Street Journal',
    link:
      'https://graphics.wsj.com/image-grid/OD50Spring2018/6336/hitch-a-ride-on-a-private-jet'
  },
  {
    title: 'JetSuite Offers Private Jet Promotion',
    date: 'February 5th, 2018',
    source: 'Business Travel Executive',
    link:
      'https://businesstravelexecutive.com/news/?permalink=jetsuite-offers-private-jet-promotion'
  },
  {
    title: "X Unlimited Offer for JetSuite's SuiteKey Members",
    date: 'February 1st, 2018',
    source: 'Robb Report',
    link:
      'https://robbreport.com/motors/aviation/x-unlimited-offer-for-jetsuites-suitekey-members-2776263/'
  },
  {
    title: 'JetSuite Launches Fly Free Jet Card Promotion With JetSuiteX',
    date: 'February 1st, 2018',
    source: 'Private Jet Card Comparisons',
    link:
      'https://privatejetcardcomparisons.com/2018/02/01/jetsuite-launches-fly-free-jet-card-promotion-with-jetsuitex/'
  },
  {
    title: 'Taking a Private Jet Could Be More Affordable Than You Think',
    date: 'January 24th, 2018',
    source: 'The New York Times',
    link:
      'https://www.nytimes.com/2018/01/24/travel/private-jet-flight-deals.html'
  }
];



// WEBPACK FOOTER //
// ./src/components/News/newsData.js